import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class HomepagePopular extends Component {
  render(){

    return(
      <div className="row">
          <div className="large-12 columns">

            <article className="feature-item">
              
              <h2 className="no-margin feature-heading">Popular places</h2>

              <div className="row">
                <div className="medium-4 columns popular-item">
                  <h3 className="no-margin">
                    <Link to="/businesses/restaurants"><i className="fa fa-cutlery" aria-hidden="true"></i>  Restaurants</Link>
                  </h3>
                </div>
                <div className="medium-4 columns popular-item">
                  <h3 className="no-margin">
                    <Link to="/businesses/pubs"><i className="fa fa-beer" aria-hidden="true"></i> Pubs</Link>
                  </h3>
                </div>
                <div className="medium-4 columns popular-item">
                  <h3 className="no-margin">
                    <Link to="/businesses/stores"><i className="fa fa-shopping-bag" aria-hidden="true"></i> Shopping</Link>
                  </h3>
                </div>
                <div className="medium-4 columns popular-item">
                  <h3 className="no-margin">
                    <Link to="/search/entertainment"><i className="fa fa-ticket" aria-hidden="true"></i> Things to do</Link>
                  </h3>
                </div>
                <div className="medium-4 columns popular-item">
                  <h3 className="no-margin">
                    <Link to="/businesses/hotels"><i className="fa fa-bed" aria-hidden="true"></i> Hotels</Link>
                  </h3>
                </div>
                <div className="medium-4 columns popular-item">
                  <h3 className="no-margin">
                    <Link to="/businesses/convenience-stores"><i className="fa fa-shopping-cart" aria-hidden="true"></i> Convenience stores</Link>
                  </h3>
                </div>
              </div>
                
            </article>

            
          </div>
        </div>
    );
  }
}
export default HomepagePopular;


// WEBPACK FOOTER //
// ./src/components/blocks/HomepagePopular.js